/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listVaultedData} from '../api'

export const useMutationListVaultedData = createReactQueryMutationHook('listVaultedData', listVaultedData)
